module.exports = __webpack_public_path__ + "static/media/aibory-logo-main@3x.9af893cf.png";